module.exports = __webpack_public_path__ + "static/img/dashboardBanner.fee998f.jpeg";